module.exports = __webpack_public_path__ + "static/media/wizualizacja-24.929ad980.png";